

































import { Prop, Component, Vue, Watch } from "vue-property-decorator";
// import { Team, User, UserStat } from "./types";
import { Getter, Action } from "vuex-class";
import { TeamLesson, Team } from "../../types";
import Trash from "@/assets/images/icons/trash.svg";
import Rename from "@/assets/images/icons/rename.svg";
import Dots from "@/assets/images/icons/dragdots.svg";
import draggable from "vuedraggable";

@Component({
  components: { Trash, Rename, Dots, draggable }
})
export default class LessonBuilder extends Vue {
  @Action private fetchTeamLessons!: (id: Number) => any;
  @Getter private teamLessons?: TeamLesson[];
  @Getter private currentTeam?: Team;

  public get dragOptions(): any {
    return {
      animation: 200,
      group: "description",
      disabled: false,
      ghostClass: "ghost"
    };
  }

  private created() {
    this.fetchTeamLessons(this.currentTeam!.ID);
  }
}
